import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography, CircularProgress,
} from '@mui/material';

interface ConfirmModalProps {
    open: boolean;
    title?: string;
    message: string;
    onConfirm: () => void;
    onCancel?: () => void;
    isLoading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    open,
    title = 'Are you sure?',
    message,
    onConfirm,
    onCancel,
    isLoading,
}) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent style={{ minWidth: 300 }}>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onCancel}
                    color="inherit"
                    variant="outlined"
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    startIcon={isLoading ? <CircularProgress size={16}/> : undefined}
                    onClick={onConfirm}
                    color="primary"
                    variant="contained"
                    disabled={isLoading}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmModal;